import React from 'react';
import * as Icons from 'lucide-react';
import { WHY_CHOOSE } from '../mock';

const WhyChoose = () => {
  return (
    <section id="about" className="py-20 bg-[#0d3d5e] text-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold">
            Why Choose Singh Logistics WA
          </h2>
          <p className="mt-4 text-slate-200 text-lg">
            Perth businesses trust us for reliable, round-the-clock refrigerated
            transport that never compromises on quality.
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {WHY_CHOOSE.map((w) => {
            const Icon = Icons[w.icon] || Icons.Check;
            return (
              <div
                key={w.title}
                className="p-6 rounded-lg bg-white/5 border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-colors duration-300"
              >
                <div className="w-12 h-12 rounded-md bg-white text-[#0d3d5e] flex items-center justify-center">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="mt-4 text-lg font-bold">{w.title}</h3>
                <p className="mt-2 text-slate-200 text-sm leading-relaxed">
                  {w.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
